import axios from 'axios'
import QS from 'qs';
import router from '../router'

if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/api'
}
else if (process.env.NODE_ENV == 'test') {
  axios.defaults.baseURL = 'http://test998/'
}
else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'https://keyanju.yuzekeji.cn'
}
else if (process.env.NODE_ENV == 'build') {
  axios.defaults.baseURL = 'http://build/demo'
}


// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.timeout = 20000
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = '?token='+store.state.Token;
    // const token = config.url.indexOf('?')===-1?'?token='+store.state.Token:'token='+store.state.Token;
    // store.state.Token && (config.url = config.url+token);
    config.headers["x-auth-token"] = (localStorage.token == undefined ?"":localStorage.token);
    return config;
  },
  error => {
    return Promise.error(error);
  });

//响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }

  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:

          localStorage.removeItem('token');
          router.replace({
            path: 'login'
          })

          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        // case 403:
        //   debugger;
        //   break;
        // // 404请求不存在
        // case 404:
        //   debugger;
        //   break;
        // case 500:
        //   debugger;
        //   break;
        // // 其他错误，直接抛出错误提示
        // default:
        //   debugger;
      }
      return Promise.reject(error.response);
    }
  }
);


export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
//文件下载 get
export function getFileDown(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      responseType: "blob"
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/*json请求头 post请求*/
export function post2(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
/*非json请求头 post请求*/
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: QS.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;'
      }
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      });
  });
}
// QS.stringify(params)
/*传输文件*/
export function postFile(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(res => {
        resolve(res.data);
      })/*  */
      .catch(err => {
        reject(err.data)
      });
  });
}

/*序列化 json*/
export function post4(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: QS.stringify(params),
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      });
  });
}
// del
export function del(url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// put
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'put',
      data: QS.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;'
      }
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// putJosn
export function putJson(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'put',
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function getFile2(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'get',
      params: params,
      responseType: "blob"
    } )
    .then(res => {
      resolve(res)
    })
    .catch(err => {
      reject(err)
    })
  })
}

export function getFile(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'get',
      params: params,
      responseType: "blob"
    } )
    .then(res => {
      resolve(res)
    })
    .catch(err => {
      reject(err)
    })
  })
}
